import React, { useState } from "react";
import BGImg from "../../Assests/Images/2001.jpg";
import { useNavigate } from "react-router-dom";

export default function RequestAppointment() {
    
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        department: "",
        doctor: "",
        consultationType: "",
        requestedDate: "",
        reason: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formData);
        navigate("/patient-dashboard");
    };

    return (
        <div
            className="min-vh-100 d-flex align-items-center justify-content-center"
            style={{
                backgroundImage: `linear-gradient(rgba(5, 17, 35, 0.62), rgba(5, 17, 35, 0.72)), url(${BGImg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}
        >
            <div className="container px-4 py-5">
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-11 col-md-9 col-lg-7 col-xl-5">
                        <div
                            className="card border-0 rounded-4 shadow-lg"
                            style={{
                                background: "rgba(255,255,255,0.88)",
                                backdropFilter: "blur(10px)",
                            }}
                        >
                            <div className="card-body p-4 p-md-5">
                                <div className="text-center mb-5">
                                    <div
                                        className="d-inline-flex align-items-center justify-content-center rounded-circle bg-light-primary text-primary mb-3"
                                        style={{ width: "64px", height: "64px" }}
                                    >
                                        <i className="bi bi-calendar2-check-fill fs-2"></i>
                                    </div>
                                    <h2 className="fw-bold text-dark mb-2">Requesting Appointment</h2>
                                    <div className="text-muted">
                                        Fill in the details below to request your appointment
                                    </div>
                                </div>

                                <form onSubmit={handleSubmit}>
                                    <div className="row g-4">
                                        <div className="col-12 col-md-6">
                                            <label className="form-label fw-semibold text-dark">
                                                Consultation Department <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                name="department"
                                                className="form-select form-select-lg"
                                                value={formData.department}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select Dept.</option>
                                                <option value="cardiology">Cardiology</option>
                                                <option value="orthopedics">Orthopedics</option>
                                                <option value="neurology">Neurology</option>
                                                <option value="general">General Medicine</option>
                                            </select>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <label className="form-label fw-semibold text-dark">
                                                Preferred Doctor
                                            </label>
                                            <select
                                                name="doctor"
                                                className="form-select form-select-lg"
                                                value={formData.doctor}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select Doctor</option>
                                                <option value="doctor-1">Dr. Kumar</option>
                                                <option value="doctor-2">Dr. Priya</option>
                                                <option value="doctor-3">Dr. Arun</option>
                                            </select>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <label className="form-label fw-semibold text-dark">
                                                Consultation Type
                                            </label>
                                            <select
                                                name="consultationType"
                                                className="form-select form-select-lg"
                                                value={formData.consultationType}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select Type</option>
                                                <option value="in-person">In Person</option>
                                                <option value="video">Video Consultation</option>
                                                <option value="follow-up">Follow Up</option>
                                            </select>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <label className="form-label fw-semibold text-dark">
                                                Requested Date <span className="text-danger">*</span>
                                            </label>
                                            <div className="input-group input-group-lg">
                                                <input
                                                    type="date"
                                                    name="requestedDate"
                                                    className="form-control"
                                                    value={formData.requestedDate}
                                                    onChange={handleChange}
                                                />
                                                <span className="input-group-text bg-white">
                                                    <i className="bi bi-calendar-event"></i>
                                                </span>
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <label className="form-label fw-semibold text-dark">
                                                Reason for Visit
                                            </label>
                                            <textarea
                                                name="reason"
                                                rows="4"
                                                className="form-control form-control-lg"
                                                placeholder="Enter reason"
                                                value={formData.reason}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        <div className="col-12">
                                            <button
                                                type="submit"
                                                className="btn btn-primary w-100 btn-lg fw-bold py-3"
                                            >
                                                <i className="bi bi-check2-circle me-2"></i>
                                                Confirm Appointment
                                            </button>
                                        </div>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
